import { PieChartType } from "./options/pie-chart.options";
import { BubbleChartType } from "./options/bubble.options";
import { TableChartType } from "./options/table.options";

export class ChartRouterComponent extends HTMLElement {
    private _chartType!: string;
    private _seriesType!: string

    connectedCallback() {
        const chartTypeAttribute = this.attributes.getNamedItem('chart-type')
        const seriesTypeAttribute = this.attributes.getNamedItem('series-type')

        if (!chartTypeAttribute || !seriesTypeAttribute) {
            throw new Error('missing chart and/or series type attributes')
        }

        this._chartType = chartTypeAttribute.value
        this._seriesType = seriesTypeAttribute.value

        if (this.isPieChart(this._chartType)) {
            this.createPieChart()
        } else if (this.isTableChart(this._chartType)) {
            this.createTableChart()
        } else if (this.isBubbleChart(this._chartType)) {
            this.createBubbleChart()
        } else {
            this.createHistoricalChart()
        }
    }

    private isChartType(chartType: string, enumObj: object): boolean {
        return Object.values(enumObj).includes(chartType);
    }

    private isBubbleChart(chartType: string): boolean {
        return this.isChartType(chartType, BubbleChartType);
    }

    private isPieChart(chartType: string): boolean {
        return this.isChartType(chartType, PieChartType);
    }

    private isTableChart(chartType: string): boolean {
        return this.isChartType(chartType, TableChartType);
    }

    private escapeAttr(value: string): string {
        return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    }

    private createTableChart(): void {
        this.innerHTML = `<tbw-table-chart chart-id="${this.escapeAttr(this._chartType)}"></tbw-table-chart>`
    }

    private createPieChart(): void {
        this.innerHTML = `<tbw-pie-chart chart-id="${this.escapeAttr(this._chartType)}"></tbw-pie-chart>`
    }

    private createHistoricalChart(): void {
        this.innerHTML = `<tbw-historical-chart chart-type="${this.escapeAttr(this._chartType)}" series-type="${this.escapeAttr(this._seriesType)}"></tbw-historical-chart>`
    }

    private createBubbleChart(): void {
        this.innerHTML = `<tbw-bubble chart-id="${this.escapeAttr(this._chartType)}"></tbw-bubble>`
    }
} 